<template>
  <div :class="classnames">
    <h5 :class="`${ns}__title`">Search.</h5>

    <div :class="`${ns}__body`">
      <div :class="`${ns}__search-field`">
        <div :class="`${ns}__search-field-display`">
          <input
            v-model="search"
            :class="`${ns}__search-field-input`"
            :placeholder="`Search by SKU or name`"
            :ref="`_$input`"
          />
        </div>

        <div :class="`${ns}__search-field-controls`">
          <interactive-svg-icon>
            <svg-icon-magnifying-glass height="13" width="13" />
          </interactive-svg-icon>
        </div>
      </div>

      <div :class="`${ns}__page-teasers-wrapper`">
        <div :class="`${ns}__page-teasers`">

          <template v-if="searching === false && results !== null">
            <div :class="`${ns}__page-teaser`"
              @click="productDetail(result.id)"
              v-for="result in results"
              :key="result.id">
              <template v-if="result.image">
                <div :class="`${ns}__page-image`">
                  <img :class="`${ns}__page-thumbnail`" :src="result.image.url" />
                </div>
              </template>

              <div :class="`${ns}__page-text`">
                <!-- <template v-if="pageSubline">
                  <div :class="`${ns}__page-subline`">{{ pageSubline }}</div>
                </template> -->

                <template v-if="result.title">
                  <div :class="`${ns}__page-headline`">{{ result.title }}</div>
                </template>

                <div :class="`${ns}__page-attributes`">
                  <div :class="`${ns}__page-attribute`">
                    <div :class="`${ns}__page-attribute-label`">Price</div>
                    <div :class="`${ns}__page-attribute-value`">
                      <span class="products__price">{{ result.price | currency }}</span>
                      <span class="products__compare-at-price" v-if="result.compareAtPrice">{{ result.compareAtPrice | currency }}</span>
                    </div>
                  </div>
                  <div :class="`${ns}__page-attribute`">
                    <div :class="`${ns}__page-attribute-label`">Variants</div>
                    <div :class="`${ns}__page-attribute-value`">{{ result.variant_list.length }} Total</div>
                  </div>
                  <div :class="`${ns}__page-attribute`">
                    <div :class="`${ns}__page-attribute-label`">Found In</div>
                    <div :class="`${ns}__page-attribute-value`">({{ result.collection_list ? result.collection_list.length : 0 }} Collections)</div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-if="searching === true && this.search.length >= this.minLength">
            <div :class="`${ns}__placeholder-text`">Searching for "{{ this.search }}"</div>
          </template>

          <template v-if="searching === false && results === null && nothingFound === true && this.search.length >= this.minLength">
            <div :class="`${ns}__placeholder-text`">No results for "{{ this.search }}"</div>
          </template>

          <template v-if="searching === false && results === null && this.search.length < 1">
            <div :class="`${ns}__placeholder-text`">Start typing to search.</div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import InteractiveSvgIcon from '@/components/InteractiveSvgIcon'

  import SvgIconMagnifyingGlass from '@/svgs/SvgIconMagnifyingGlass'

  import axios from 'axios'
  import _debounce from 'lodash/debounce'
  import { bem } from '@/mixins/bem.js'

  const namespace = 'modal-view-search'

  export default {
    name: 'ModalViewSearch',
    components: {
      'interactive-svg-icon': InteractiveSvgIcon,
      'svg-icon-magnifying-glass': SvgIconMagnifyingGlass
    },
    mixins: [ bem ],
    props: {
      minLength: {
        type: Number,
        default: 1
      }
    },
    data: function () {
      return {
        nothingFound: false,
        searching: false,
        search: '',
        productsUrl: `${this.$domain}/products`,
        results: null
      }
    },
    watch: {
      'search': function () {
        this.initializeSearch()
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    mounted: function () {
      const that = this

      that.$nextTick(function () {
        setTimeout(function () {
          that.focusInputField()
        }, 200)
      })
    },
    methods: {
      focusInputField: function () {
        let documentHasFocus = document.hasFocus()
        let currentTagName = ''
        const lastTagName = 'BODY'

        while (documentHasFocus && currentTagName !== lastTagName) {
          const _$activeElement = document.activeElement
          currentTagName = _$activeElement.tagName

          _$activeElement.blur()

          documentHasFocus = document.hasFocus()
        }

        // console.log('done')
        // console.log('this.$refs._$input')
        // console.log(this.$refs._$input)

        this.$refs._$input.focus()

        // console.log('document.activeElement')
        // console.log(document.activeElement)
      },
      loadSearch () {
        this.searching = true

        const params = {
          search: this.search,
          limit: 10
        }

        return axios({
          method: 'get',
          url: this.productsUrl,
          params: params
        })
        .then((response) => {
          this.searching = false

          const totalProducts = response.data.products.length

          if (totalProducts > 0) {
            this.results = response.data.products
          } else {
            this.results = null
            this.nothingFound = true
          }
        })
        .catch((error) => {
          this.searching = false

          console.log(error)
        })
      },
      productDetail (productId) {
        const params = {
          productId: productId
        }

        this.$router.push({name: 'Product Detail', params: params})

        this.$emit('closeModal')
      },
      resetSearch () {
        this.results = null
        this.searching = false
        this.nothingFound = false
      },
      initializeSearch: function () {
        if (this.search.length >= this.minLength) {
          this.searching = true
        }

        this.searchDebounce()
      },
      searchDebounce: _debounce(function () {
        if (this.search.length >= this.minLength) {
          this.loadSearch()
        } else {
          this.resetSearch()
        }
      }, 500)
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/ModalViewSearch.vue